// Status drives which due date to show: UF/F shows forfeiture, UJ/J shows judgment
export const getDueDate = (power) => {
  const status = power.powerStatus;
  if (status === 'UF' || status === 'F') return power.forfeitureDueDate || null;
  if (status === 'UJ' || status === 'J') return power.judgmentDueDate || null;
  return null;
};

// Yellow when a due date is set, red once that date is past (compared at day granularity)
export const getDueDateHighlight = (dueDate) => {
  if (!dueDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(dueDate);
  due.setHours(0, 0, 0, 0);
  if (Number.isNaN(due.getTime())) return null;
  if (due < today) {
    return {
      cell: 'bg-red-600 dark:bg-red-700',
      text: 'text-white font-bold',
    };
  }
  return {
    cell: 'bg-yellow-100 dark:bg-yellow-900/40',
    text: '',
  };
};
